import React from 'react';
import PropTypes from 'prop-types';
import {
  MultipleChoiceQuiz,
  TrueFalseQuiz,
  FillInTheBlank,
  MatchingProblem,
  SentenceRearrangement
} from '../QuizTypes';
import { getSubjectName } from '../../../utils/quizUtils';

const QuestionRenderer = ({ 
  question, 
  currentQuestionIndex,
  answered, 
  isTimeUp,
  onSubmit,
  contentDetails
}) => {
  if (!question) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-600">このコンテンツにはクイズがありません。</p>
      </div>
    );
  }

  const quickAnswerMode = contentDetails?.quickAnswerMode || 'standard';

  const renderQuestionByType = () => {
    switch (question.type) {
      case 'multiple-choice':
        return (
          <MultipleChoiceQuiz 
            question={question} 
            answered={answered} 
            isTimeUp={isTimeUp}
            handleSubmit={onSubmit}
            quickAnswerMode={quickAnswerMode}
          />
        );
      case 'true-false':
        return (
          <TrueFalseQuiz 
            question={question} 
            answered={answered} 
            isTimeUp={isTimeUp}
            handleSubmit={onSubmit}
            quickAnswerMode={quickAnswerMode}
          />
        );
      case 'fill-in-the-blank':
        return (
          <FillInTheBlank 
            question={question} 
            answered={answered} 
            isTimeUp={isTimeUp}
            handleSubmit={onSubmit}
            quickAnswerMode={quickAnswerMode}
          />
        );
      case 'matching':
        return (
          <MatchingProblem 
            question={question} 
            answered={answered} 
            isTimeUp={isTimeUp}
            handleSubmit={onSubmit}
            quickAnswerMode={quickAnswerMode}
          />
        );
      case 'sentence-rearrangement':
        return (
          <SentenceRearrangement 
            question={question} 
            answered={answered} 
            isTimeUp={isTimeUp}
            handleSubmit={onSubmit}
            quickAnswerMode={quickAnswerMode}
          />
        );
      default:
        return (
          <div className="text-center py-8">
            <p className="text-gray-600">不明なクイズ形式です。</p>
          </div>
        );
    }
  };

  return (
    <div className="space-y-4">
      {/* 質問情報ヘッダー */}
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-2">
          <span className="inline-block bg-purple-100 text-purple-800 px-3 py-1 rounded-full text-sm">
            {getSubjectName(question.subject)}
          </span>
          <span className="text-sm text-gray-500">
            {question.contentTitle}
          </span>
        </div>
      </div>

      {/* 質問コンテンツ */}
      <div className="bg-white rounded-lg border p-6">
        {renderQuestionByType()}
      </div>
    </div>
  );
};

QuestionRenderer.propTypes = {
  question: PropTypes.object,
  currentQuestionIndex: PropTypes.number.isRequired,
  answered: PropTypes.bool.isRequired,
  isTimeUp: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  contentDetails: PropTypes.object,
};

export default QuestionRenderer; 